const styles = theme => ({
  priceWidth: {
    width: '100px',
  },
})

export default styles
